<template>
  <div
    class="reference-uniform-list-subcategories-subcat"
    :class="{
      'cursor-pointer': hasChildren,
    }"
    @click="hasChildren && $emit('toggle')"
  >
    <div
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        boundary: 'window',
        content: !hasChildren ? 'Пустая категория' : '',
        placement: 'top',
      }"
      :class="{
        'collapsed': category.isVisible,
        'not-collapsed': !category.isVisible,
        'reference-uniform-list-subcategories-subcat-show-button-disabled': !hasChildren,
      }"
      class="reference-uniform-list-subcategories-subcat-show-button"
    >
      <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z"
          fill="#0066FF"
        />
        <path
          d="M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z"
          fill="#0066FF"
        />
      </svg>
    </div>
    <div class="reference-uniform-list-subcategories-subcat-content">
      <div class="reference-uniform-list-subcategories-subcat-name">
        {{ category.name }}
        <span v-if="!hasChildren" class="empty">(пусто)</span>
      </div>
      <div v-if="responsible" class="reference-uniform-list-subcategories-subcat-responsible">
        <a :href="`/index.php?r=redesign#/personal-employee/${responsible.id}/summary`" target="_blank">{{
          responsible.name
        }}</a>
      </div>
    </div>
    <div class="reference-uniform-list-subcategories-subcat-buttons">
      <c-button
        v-if="category.descriptionModel && category.descriptionModel.hasDescription"
        class="reference-uniform-list-subcategories-subcat-buttons-comment"
        size="iconic"
        icon="comment"
        @click="$emit('showDescription')"
      />
      <c-button
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: 'Редактировать',
          placement: 'top',
        }"
        class="reference-uniform-list-subcategories-subcat-buttons-edit"
        size="iconic"
        icon="edit"
        @click.stop="$emit('edit')"
      />
      <c-button
        v-if="!hasChildren"
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          boundary: 'window',
          content: 'Удалить',
          placement: 'top',
        }"
        class="reference-uniform-list-subcategories-subcat-buttons-trash"
        size="iconic"
        icon="trash"
        @click.stop="$emit('remove')"
      />
      <c-button
        v-if="hasChildren"
        :id="'subCategory_empty_' + _uid"
        class="reference-uniform-list-subcategories-subcat-buttons-trash reference-uniform-list-subcategories-subcat-buttons-trash-disabled"
        size="iconic"
        icon="trash"
        @click.stop
      />
      <b-popover
        placement="top"
        container="app"
        boundary="window"
        :target="'subCategory_empty_' + _uid"
        triggers="hover blur"
      >
        <div class="reference-uniform-category-empty-tooltip">
          <svg
            class="reference-uniform-category-empty-tooltip-icon"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
            <circle cx="7" cy="10" r="1" fill="#FF238D" />
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
          </svg>
          <div class="reference-uniform-category-empty-tooltip-text">
            В данный момент удаление невозможно, так как категория содержит данные. Сначала перенесите все данные из
            категории.
          </div>
        </div>
      </b-popover>
    </div>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";

export default {
  components: { CButton },
  props: ["category"],
  computed: {
    workersList() {
      return this.$store.getters["actors/workersList"].map((worker) => ({
        id: `${worker.value}`,
        name: worker.label,
      }));
    },
    responsible() {
      const { responsible } = this.category;
      if (!responsible) return null;
      const id = responsible.toString();
      return this.workersList.find((worker) => worker.id === id);
    },
    hasChildren() {
      return (this.category.subCategories && this.category.subCategories.length) || ( this.category.types && this.category.types.length);
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-uniform {
  &-list {
    &-subcategories {
      &-subcat {
        margin-left: 16px;
        width: calc(100% - 16px);
        max-width: calc(100% - 16px);
        display: flex;
        align-items: center;
        border: 1px solid #dfe4ef;
        padding: 13px 16px;
        background: #f5f7fa;

        .empty {
          color: #8e9cbb;
          font-size: 11px;
          font-weight: normal;
        }

        @media screen and (max-width: 700px) {
          margin-left: 19px;
          border-right: none;
          width: calc(100% - 19px);
          max-width: calc(100% - 19px);
        }

        &-show-button {
          width: 22px;
          min-width: 22px;
          height: 22px;
          margin-right: 14px;
          border-radius: 50%;
          cursor: pointer;
          background: #ffffff;
          border: 1px solid #d3d8df !important;
          box-sizing: border-box;
          position: relative;

          & svg {
            position: absolute;
            left: 50%;
            top: calc(50% + 1px);
            transform: translate(-50%, -50%);
          }

          &-disabled {
            opacity: 0.5;
          }

          &.not-collapsed svg {
            //margin-top: 2px;
          }

          &.collapsed svg {
            -webkit-transform: translate(-50%, calc(-50% - 1px)) rotate(180deg);
            -moz-transform: translate(-50%, calc(-50% - 1px)) rotate(180deg);
            transform: translate(-50%, calc(-50% - 1px)) rotate(180deg);
          }
        }

        &-content {
          flex-grow: 1;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          align-items: center;

          @media screen and (max-width: 700px) {
            flex-direction: column;
            align-items: flex-start;
          }
        }

        &-name {
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 15px;
          line-height: 108%;
          color: #000000;
          max-width: calc(100% - 104px);
          overflow-wrap: break-word;
        }

        &-responsible {
          font-size: 11px;
        }

        &-buttons {
          display: flex;
          align-items: center;
          margin-left: auto;
          justify-content: flex-end;
          min-width: 100px;
          padding-left: 15px;
          flex-shrink: 0;

          @media screen and (max-width: 700px) {
            min-width: 0;
          }

          &-comment {
            margin-top: -2px;
          }

          &-edit {
            margin-left: 14px;
          }

          &-trash {
            &-disabled {
              opacity: 0.5;
            }
            margin-top: -2px;
            margin-left: 14px;
          }
        }
      }
    }
  }
}
</style>
